import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlockUIDirective } from './block-ui.directive';
import { BlockUIService } from './block-ui.service';
import { setBlockUIServiceRef } from './block-ui.decorator';

/**
 * Drop-in replacement for ng-block-ui's BlockUIModule. Supports both `BlockUIModule`
 * and `BlockUIModule.forRoot()` usage. Wires the module-level service reference so the
 * @BlockUI property decorator can reach the service.
 */
@NgModule({
  imports: [CommonModule],
  declarations: [BlockUIDirective],
  exports: [BlockUIDirective],
})
export class BlockUIModule {
  constructor(blockUIService: BlockUIService) {
    setBlockUIServiceRef(blockUIService);
  }
  static forRoot(): ModuleWithProviders<BlockUIModule> {
    return { ngModule: BlockUIModule, providers: [BlockUIService] };
  }
}
